import React, { useState, useEffect } from "react";

const FileViewerModal = ({ document, onClose }) => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
    }, [document]);

    if (!document) return null;

    const ext = document.document_name.split(".").pop()?.toLowerCase();
    const fileUrl = document.document_path;
    const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(ext);
    const isPDF = ext === "pdf";
    const isOffice = ["doc", "docx", "ppt", "pptx", "xls", "xlsx"].includes(ext);
    const viewerUrl = isOffice
        ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`
        : isPDF
            ? `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`
            : null;

    return (
        // <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center">
        <div className="fixed inset-0 bg-black bg-opacity-70 z-[2000] flex items-center justify-center">
            <div className="relative w-11/12 max-w-5xl bg-white rounded shadow-lg">
                {/* Header */}
                <div className="flex justify-between items-center px-4 py-2 border-b">
                    <h2 className="text-md font-semibold truncate">{document.document_name}</h2>
                    <button
                        className="text-sm px-3 py-1 bg-red-500 text-white rounded"
                        onClick={onClose}
                    >
                        Close
                    </button>
                </div>

                {/* Viewer */}
                <div className="relative w-full h-[80vh] overflow-hidden">
                    {loading && (
                        <div className="absolute inset-0 z-20 flex items-center justify-center bg-white bg-opacity-90">
                            <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                        </div>
                    )}

                    {isImage ? (
                        <img
                            src={fileUrl}
                            alt={document.document_name}
                            onLoad={() => setLoading(false)}
                            className="w-full h-full object-contain select-none"
                            onContextMenu={(e) => e.preventDefault()}
                        />
                    ) : (
                        <iframe
                            src={viewerUrl}
                            title={document.document_name}
                            sandbox="allow-scripts allow-same-origin allow-forms"
                            className="w-full h-full"
                            onLoad={() => setLoading(false)}
                        />
                    )}

                    {/* Watermark */}
                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-30 z-10">
                        <span className="text-4xl font-bold text-red-500 rotate-45">CONFIDENTIAL</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FileViewerModal;
